import { Component } from '@angular/core';
import { MAPSPersonJobEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Person Jobs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapspersonjob-form',
    templateUrl: './mapspersonjob.form.component.html'
})
export class MAPSPersonJobFormComponent extends BaseFormComponent {
    public record!: MAPSPersonJobEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

